import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CloseSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 12 12",
  color = "#ccc",
  opacity,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      opacity={opacity}
      {...rest}
    >
      <path
        d="M11.25.526a.83.83 0 00-1.175 0L6 4.592 1.925.517A.83.83 0 10.75 1.692l4.075 4.075L.75 9.842a.83.83 0 101.175 1.175L6 6.942l4.075 4.075a.83.83 0 101.175-1.175L7.175 5.767l4.075-4.075a.835.835 0 000-1.166z"
        fill={color}
      />
    </svg>
  );
};

export { CloseSvg };
